import React from 'react';
import PropTypes from 'prop-types';

const HoverIcon = ({
    icon, hoverIcon, styles
}) => (
    <>
        <img alt="" src={ icon } className={ styles['hover-icon-primary'] } />
        <img alt="" src={ hoverIcon } className={ styles['hover-icon-hover'] } />
    </>
);

HoverIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    hoverIcon: PropTypes.string.isRequired,
    styles: PropTypes.objectOf(PropTypes.string).isRequired,
    restprops: PropTypes.shape({})
};

HoverIcon.defaultProps = {
    restprops: {}
};

export default HoverIcon;
